// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2025 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { Card, HomepageSectionHeading, SlateCopy } from "~@jii/common-ui";
import { useUsMaTranslations } from "~@jii/translation";

import { useEGTDataContext } from "../../EGTDataContext/context";
import { DateInfo } from "./DateInfo";
import { MAXCard } from "./MAXCard";
import { RTSCard } from "./RTSCard";

export const DatesSection = () => {
  const { data } = useEGTDataContext();
  const { t } = useUsMaTranslations();

  // if we have an RTS date or if both dates are null, put RTS first
  const showRTSFirst = !!(data.rtsDate || !data.adjustedMaxReleaseDate);

  return (
    <section>
      <HomepageSectionHeading>
        {t(($) => $.home.dates.sectionTitle)}
      </HomepageSectionHeading>
      {showRTSFirst ? (
        <>
          <RTSCard />
          <MAXCard />
        </>
      ) : (
        <>
          <MAXCard />
          <RTSCard />
        </>
      )}
      <Card>
        <DateInfo
          {...t(($) => $.home.dates.parole, { returnObjects: true })}
          muted
        />
        <SlateCopy>{t(($) => $.home.dates.parole.summary)}</SlateCopy>
      </Card>
    </section>
  );
};
